import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import {
  contactEmail,
  navLinks,
  siteBrand,
  siteName,
  siteTagline,
} from '@/mocks/site';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto w-full bg-secondary-950 text-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-archive-2-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{siteBrand}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              收录人物库与历史记录，深挖旧事背景与秘史脉络。从源头梳理背景，补全碎片化信息，帮你看懂事件的完整逻辑。
            </p>
            <p className="mt-4 text-xs tracking-widest text-secondary-300">{siteTagline}</p>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">站点导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 transition-colors hover:text-primary-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">栏目分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/topics?category=${encodeURIComponent(cat.name)}`}
                    className="text-sm text-background-300 transition-colors hover:text-primary-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-background-50">联系档案中心</h3>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              发现条目有误、或希望提供可公开核对的材料，欢迎来信。
            </p>
            <a
              href={`mailto:${contactEmail}`}
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap text-sm text-primary-300 transition-colors hover:text-primary-200"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              {contactEmail}
            </a>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-900 text-background-200">
                <i className="ri-file-list-3-line" aria-hidden="true"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-900 text-background-200">
                <i className="ri-bookmark-line" aria-hidden="true"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-900 text-background-200">
                <i className="ri-archive-line" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="mx-auto flex max-w-content flex-col gap-3 px-4 py-5 text-xs text-background-400 md:flex-row md:items-center md:justify-between md:px-8">
          <p>
            © {year} {siteName} · 内容以公开可核对材料整理，仅供研究与阅读参考
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link to="/about" className="whitespace-nowrap transition-colors hover:text-primary-300">
              关于我们
            </Link>
            <span className="whitespace-nowrap">{contactEmail}</span>
          </p>
        </div>
      </div>
    </footer>
  );
}